import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Events} from "../../../../../../framework/providers/events";
import {IonContent, ModalController, PopoverController} from "@ionic/angular";
import {BusinessService} from "../../../../../../core/services/BusinessService";
import {CatalogAdminService} from "../../../../services/catalogAdminService";
import {AppDataService} from "../../../../../../core/services/AppDataService";
import {AdminService} from "../../../../services/AdminService";
import {ModelToolsProvider} from "../../../../../../framework/providers/model-tools/model-tools";
import {TranslateService} from "@ngx-translate/core";
import {OrderService} from "../../../../../../core/services/OrderService";

@Component({
    selector: 'app-catalog-tree',
    templateUrl: './catalog-tree.component.html',
    styleUrls: ['./catalog-tree.component.scss'],
})
export class CatalogTreeComponent implements OnInit, OnDestroy {
    @Input()
    contentRef;

    public ready = true;

    subSections = [];
    currentSection = null;
    currentSectionId = null;
    public current_path = [];

    constructor(public events: Events, public popoverCtrl: PopoverController,
                public businessService: BusinessService, public catalogAdminService: CatalogAdminService,
                public appDataService: AppDataService, public adminService: AdminService,
                public tools: ModelToolsProvider,
                public translate: TranslateService,
                public orderService: OrderService, public modalController: ModalController) {
    }

    ngOnInit() {
        let me = this;
        this.events.subscribe('appDataSets', function () {
            me.refresh();
        });
        this.currentSectionId = null;
        this.loadSectionSubs();
    }

    ngOnDestroy() {
    }

    clickModel(event, model) {
        this.currentSectionId = model.data.id;
        this.catalogAdminService.markItem('section', model);
    }

    refresh() {
        // return
        // this.catalogAdminService.refresh();
        // if (this.orderService.showStaffButtons) {
        //     this.catalogAdminService.appDataService.createNoItemsSection();
        // }
        // this.catalogAdminService.appDataService.fixSectionsData();
        //
        // this.currentSectionId = null;
        // this.loadSectionSubs(this.currentSectionId);


        let me = this;
        me.ready = false;
        setTimeout(function () {
            me.ready = true;
        })
    }

    upSectionSubs() {
        this.loadSectionSubs(this.current_path[this.current_path.length - 1].data.sectionId);
        this.current_path_remove();
    }

    readyonoff() {
        let me = this;
        me.ready = false;
        setTimeout(function () {
            me.ready = true;
            me.contentRef.scrollToTop(500);
        })
    }

    loadSectionSubs(sectionId = null) {
        this.currentSection = this.catalogAdminService.sections[sectionId];
        this.currentSectionId = sectionId;
        this.subSections.length = 0;
        // for (let sectId in this.catalogAdminService.sections) {
        //     if (this.catalogAdminService.sections[sectId].data.sectionId == this.currentSectionId) {
        //         this.subSections.push(this.catalogAdminService.sections[sectId]);
        //     }
        // }
        if (!sectionId) {
            for (let sectId of this.catalogAdminService.topSections) {
                if (this.catalogAdminService.sections[sectId].data.sectionId == this.currentSectionId) {
                    this.subSections.push(this.catalogAdminService.sections[sectId]);
                }
            }
        } else {
            for (let sectId of this.catalogAdminService.sections[sectionId]['sections']) {
                if (this.catalogAdminService.sections[sectId].data.sectionId == this.currentSectionId) {
                    this.subSections.push(this.catalogAdminService.sections[sectId]);
                }
            }
        }
    }


    current_path_add(section) {
        this.current_path.push(section);
    }

    current_path_remove(empty = false) {
        if (empty) {
            this.current_path.length = 0;
        } else {
            this.current_path.pop();
        }
    }

    update_section_view() {
        this.loadSectionSubs(this.currentSectionId);
        this.readyonoff();
        this.events.publish('refresh_section_' + this.currentSectionId);
    }
}
